/// <amd-module name="VSSUI/Components/DatePicker/DateStringHelper" />

import * as Resources from "VSSUI/Resources.DatePicker";
export function datePickerStrings() {
    return {
        months: [
            Resources.january,
            Resources.february,
            Resources.march,
            Resources.april,
            Resources.may,
            Resources.june,
            Resources.july,
            Resources.august,
            Resources.september,
            Resources.october,
            Resources.november,
            Resources.december
        ],
        shortMonths: [
            Resources.jan,
            Resources.feb,
            Resources.mar,
            Resources.apr,
            Resources.may,
            Resources.jun,
            Resources.jul,
            Resources.aug,
            Resources.sep,
            Resources.oct,
            Resources.nov,
            Resources.dec
        ],
        days: [Resources.sunday, Resources.monday, Resources.tuesday, Resources.wednesday, Resources.thursday, Resources.friday, Resources.saturday],
        shortDays: [Resources.sun, Resources.mon, Resources.tue, Resources.wed, Resources.thu, Resources.fri, Resources.sat],
        goToToday: Resources.goToToday,
        clear: Resources.clearDateButton,
        prevMonthAriaLabel: Resources.prevMonthAriaLabel,
        nextMonthAriaLabel: Resources.nextMonthAriaLabel,
        prevYearAriaLabel: Resources.prevYearAriaLabel,
        nextYearAriaLabel: Resources.nextYearAriaLabel
    };
}
